import React, { useState } from 'react';
import { useAdminEdit } from '../contexts/AdminEditContext';
import { Edit, Eye, RotateCcw, X } from 'lucide-react';

const AdminEditToggle = () => {
  const { isEditMode, toggleEditMode, restoreDefaults, isAdmin } = useAdminEdit();
  const [showRestoreMenu, setShowRestoreMenu] = useState(false);

  if (!isAdmin) {
    return null;
  }

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3">
      {isEditMode && (
        <div className="flex flex-col gap-2">
          <button
            onClick={() => setShowRestoreMenu(!showRestoreMenu)}
            className="p-3 bg-orange-600 hover:bg-orange-700 text-white rounded-full shadow-lg transition-all"
            title="Restore Options"
          >
            <RotateCcw className="w-5 h-5" />
          </button>
          {showRestoreMenu && (
            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl border border-gray-200 dark:border-gray-700 p-3 min-w-[200px]">
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm font-semibold text-gray-900 dark:text-gray-50">Restore Options</span>
                <button
                  onClick={() => setShowRestoreMenu(false)}
                  className="p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded"
                >
                  <X className="w-4 h-4 text-gray-500" />
                </button>
              </div>
              <button
                onClick={() => {
                  restoreDefaults();
                  setShowRestoreMenu(false);
                }}
                className="w-full px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg text-sm font-medium transition-colors flex items-center justify-center gap-2"
              >
                <RotateCcw className="w-4 h-4" />
                Restore All to Default
              </button>
            </div>
          )}
        </div>
      )}
      <button
        onClick={toggleEditMode}
        className={`p-4 rounded-full shadow-lg transition-all ${
          isEditMode
            ? 'bg-red-600 hover:bg-red-700 text-white'
            : 'bg-primary-600 hover:bg-primary-700 text-white'
        }`}
        title={isEditMode ? 'Exit Edit Mode' : 'Enter Edit Mode'}
      >
        {isEditMode ? (
          <Eye className="w-6 h-6" />
        ) : (
          <Edit className="w-6 h-6" />
        )}
      </button>
    </div>
  );
};

export default AdminEditToggle;
